<template>
    <v-dialog v-model="dialog" width="700" :fullscreen="isMobileOrTablet()" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div class="w-75 text-truncate text-white">
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12">
                            <v-text-field
                                v-model="so_number"
                                :rules="[formRules.required]"
                                label="SO Number"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-file-input
                                v-model="files"
                                accept="application/pdf"
                                label="Files Attachment (Optional, PDF only)"
                                type="file"
                                multiple
                                clearable
                                show-size
                                chips
                                rounded="lg"
                                scrim="darkGreen"
                                variant="outlined"
                                prepend-icon="mdi-file"
                            />
                        </v-col>
                        <v-col cols="12" v-if="action === 'edit' && filesList && filesList.length > 0">
                            <span class="font-weight-bold">Attachments:</span>
                            <v-card v-for="file in filesList" :key="file" class="my-2" elevation="2">
                                <v-card-text>
                                    <a @click="showViewFileDialog(file)" style="color: #1a5b0f; text-decoration: underline; cursor: pointer;">
                                        {{ file }}
                                    </a>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea
                                v-model="description"
                                :rules="[formRules.required]"
                                label="Description"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                >
                            </v-textarea>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="hours"
                                label="Hours"
                                variant="outlined"
                                rounded="lg"
                                type="number"
                                color="darkGreen"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="unit"
                                label="Unit"
                                variant="outlined"
                                rounded="lg"
                                type="number"
                                color="darkGreen"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-checkbox
                                v-model="to_be_counted"
                                label="To be counted?">
                            </v-checkbox>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="loading" text="Save" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <ViewFileDialog ref="ViewFileDialog"/>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'
import ViewFileDialog from './ViewFileDialog.vue';

export default defineComponent({
    emits: ["refresh"],
    components: {
        ViewFileDialog
    },
    data(){
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            id: null,
            so_number: null,
            description: null,
            hours: null,
            unit: null,
            user_id: null,
            to_be_counted: true,
            semester_schoolyear: null,
            files: null,
            filesList: [],
        }
     },
     methods: {
        initAdd(data){
            this.dialog = true
            this.dialog_title = 'ADMIN Load Release'
            this.dialog_sub_title = 'Add new admin load release'
            this.action = 'add'

            this.user_id = data.id
            this.to_be_counted = true
            this.semester_schoolyear = this.$store.state.semester_schoolyear.id
            this.files = null
            this.filesList = []
        },
        initUpdate(data){
            this.dialog = true
            this.dialog_title = 'ADMIN Load Release'
            this.dialog_sub_title = 'Update admin load release details'
            this.action = 'edit'

            this.id = data.id
            this.so_number = data.so_number
            this.description = data.description
            this.hours = data.hours
            this.unit = data.unit
            this.to_be_counted = data.to_be_counted
            this.files = null
            this.filesList = data.files ? data.files.split(',') : []
        },
        async validateForm(){
            const { showSnackbar } = useSnackbar()
            const { valid } = await this.$refs.form.validate()

            if(valid){
                this.loading = true
                const formData = new FormData();
                formData.append('id', this.id);
                formData.append('so_number', this.so_number);
                formData.append('description', this.description);
                formData.append('hours', this.hours);
                formData.append('unit', this.unit);
                formData.append('user_id', this.user_id);
                formData.append('to_be_counted', this.to_be_counted ? 1 : 0);
                formData.append('semester_schoolyear', this.semester_schoolyear);
                if(this.files && this.files.length > 0){
                    for(let i=0; i<this.files.length; i++){
                        formData.append('files', this.files[i]);
                    }
                }

                const token = localStorage.getItem('aums-token')

                if(this.action == 'add'){
                    axios.post(process.env.VUE_APP_SERVER_URL + '/admin-load', formData,
                    { headers:
                        { 
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                    ).then((res)=>{
                        if(res.data.status == 200){
                            this.loading = false
                            this.$emit('refresh')
                            showSnackbar('Admin Load Release successfully added!')
                            this.$refs.form.reset()
                            this.dialog = false
                        }
                    }).catch((error)=>{
                        if(error.response && error.response.status == 401){
                            this.loading = false
                            showSnackbar('Token expired! Logging out..')

                            localStorage.removeItem("vuex");
                            localStorage.removeItem("aums-token");
                            window.location.reload();
                        }
                        else{
                            console.log(error)
                        }
                    })
                }
                else if(this.action == 'edit'){
                    axios.patch(process.env.VUE_APP_SERVER_URL + '/admin-load/' + this.id, formData,
                    { headers:
                        { 
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                    ).then((res)=>{
                        if(res.data.status == 200){
                            this.loading = false
                            this.$emit('refresh')
                            showSnackbar('Admin Load Release successfully updated!')
                            this.snackbar = true
                            this.$refs.form.reset()
                            this.dialog = false
                        }
                    }).catch((error)=>{
                        if(error.response && error.response.status == 401){
                            this.loading = false
                            showSnackbar(this.snackText = 'Token expired! Logging out..')

                            localStorage.removeItem("vuex");
                            localStorage.removeItem("aums-token");
                            window.location.reload();
                        }
                        else{
                            console.log(error)
                        }
                    })
                }
            }
        },
        showViewFileDialog(file) {
            this.$refs.ViewFileDialog.viewFile(file);
        },
        closeDialog(){
            this.$refs.form.reset()
            this.dialog = false
        }
     }
})
</script>

<style scoped>

</style>